import type { CompanyArtistContactType } from '@api';
import {
  ContactDetails,
  PersonAnchor,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { Box } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { hasRenderableContact } from './helpers';
import classes from './CompanyArtistsTableRow.module.css';

type CompanyArtistsTableRowPropsType = {
  row: CompanyArtistContactType;
};

export const CompanyArtistsTableRow: React.FC<
  CompanyArtistsTableRowPropsType
> = ({ row }) => {
  const { t } = useTranslation();

  const showContactDetails = hasRenderableContact(row.contact);

  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>
        {t(`COMPANY_LINKS.CATEGORIES.${row.category}`)}
      </TouringCardTableRowLabel>
      <TouringCardTableRowValue>
        <Box className={classes.personCell}>
          <PersonAnchor person={row.person} />
        </Box>
      </TouringCardTableRowValue>
      <TouringCardTableRowValue>
        <Box className={classes.contactCell}>
          {showContactDetails && row.contact ? (
            <ContactDetails contact={row.contact} />
          ) : (
            t('NO_DATA_PLACEHOLDER')
          )}
        </Box>
      </TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};
